<template>
    <div>
        <v-header title="电子执业证"></v-header>
        <div class="conH"></div>
        <el-card class="box-card" shadow="never">
            <div slot="header" class="el-card__header">
                <span class="msgFont">证件过期提醒：{{outTimeMsg}}</span>
                <i class="el-icon-close" style="float: right; padding: 10px 10px" @click="closeMsg()"></i>
            </div>
            <div class="card-body">
                <div class="cardName">电子名片</div>
                <div class="base-card">
                    <img class="headImg" :src="result.headUrl">
                    <div class="baseMsg">
                        <div class="line">
                            <span>{{result.agentName}}</span><span>{{result.rankName}}</span>
                        </div>
                        <div class="line">
                            <span>业务编码</span><span>{{result.pid}}</span>
                        </div>
                        <div class="line">
                            <span>从业年限</span><span>{{result.workTime}}年</span>
                        </div>
                    </div>
                </div>
            </div>
        </el-card>
        <el-card class="box-tcard" shadow="never">
            <div class="cardName">保监会执业证</div>
                <div class="base-tcard">
                <img v-bind:disabled="isDisplay" v-image-preview :src="result.license.licenseUrl" height="100%" width="100%"/>
                <div class="card-font">{{result.license.licenseName}}</div>
            </div>
            <div class="cardName">公司证书</div>
            <div v-for="a in  totalNum" :key="a">
                <div class="base-hcard">
                    <img v-image-preview :src="result.licenses[a-1].licenseUrl"  height="100%" width="100%"/>
                    <div class="card-font">{{result.licenses[a-1].licenseName}}</div>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
import api from '@/modules/api.js'
import url from '@/modules/url.js'
import vHeader from '@/layout/Header1.vue'
export default {  
  name: 'certificate',
  components: {vHeader},
  data () {
    return {
      loading: true,
      result: {

      },
      totalNum: '',
      outTime: '',
      outTimeMsg: '',
      isDisplay: false
    }
  },
  methods: {
    closeMsg () {
      let hide = document.getElementsByClassName('el-card__header')
      hide[0].style.display = 'none'
    },
    closeMsg2 (options) {
      if (options) {
        let hide = document.getElementsByClassName('el-card__header')
        hide[0].style.display = 'none'
      }
    },
    getCertificates () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
        // target: document.querySelector('#getPolicyList')
      })
      let that = this
      let reqVo = {}
      api.post(url.getCertificates, reqVo, function (res) {
        that.result = res.data
        that.totalNum = that.result.licenses.length
        //console.log(that.result,"123143243");
        if (that.totalNum > 5) {
          that.totalNum = 5
        }

        that.outTime = true

        let flag = that.result.license.flag
        if (flag === 1) {
          that.outTime = false
          that.outTimeMsg = that.outTimeMsg + that.result.license.licenseName
        }

        let comLicense = that.result.licenses
        for (var item in comLicense) {
          if (comLicense[item].flag === 1) {
            that.outTime = false
            that.outTimeMsg = that.outTimeMsg + comLicense[item].licenseName + ' '
          }
        }
      })
      loading.close();
    }
  },
  mounted () {
    this.getCertificates()
  },
  updated () {
    this.closeMsg2(this.outTime)
  }
}
</script>

<style scoped>

.el-card{
    margin: 10px;
}
.el-card__header {
    padding: 0;
    background: #ECF8FF;
    color: #194793;
    height: 35px;
    font-size: 15px;
}
.msgFont{
    float: left;
    margin: 7px 10px 10px 20px;
    color: red;
}
.card-body{
    height: 284px;
}
.cardName{
    color: #C6A970;
    font-size: 20px;
}
.box-tcard{
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 30px;
}
.base-card{
    border: 1px solid #D7D7D7;
    border-radius: 5px;
    margin: 35px auto 0 auto;
    height: 203px;
    width: 461px;
}
.base-tcard{
    float: unset;
    border: 1px solid #D7D7D7;
    margin: 35px auto 20px auto;
    height: 161px;
    width: 255px;
}
.base-hcard{
    float: left;
    border: 1px solid #D7D7D7;
    margin: 35px auto 20px 20px;
    height: 161px;
    width: 255px;
}
.headImg{
    margin-top: 25px;
    margin-left: 25px;
}
.baseMsg{
    height: 175px;
    width: 300px;
    float: right;
    padding-top: 25px;
    font-size: 16px;
}
.line{
    /* width: 260px; */
    width: 94%;
    height: 56px;
    margin: 0 auto;
    line-height: 56px;
}
.line:not(:nth-child(3)){
    border-bottom:1px solid #DFDFDF;
}
.line :nth-child(odd){
    display: block;
    float: left;
    width: 32%;
}
.card-font{
    text-align: center;
    margin-top: 6px;
}

</style>
<style>
.vue-directive-image-previewer{z-index: 1006;}
</style>



// WEBPACK FOOTER //
// src/pages/performance/certificate.vue